import ko from 'knockout';
import { closePopups, openPopup } from '../init';

export enum PopupStatus {
    Open = 'open',
    Close = 'close',
}

export const isPopupOpen = (status: PopupStatus): boolean => {
    return status === PopupStatus.Open;
};

export const togglePopup = (popupId: string, status: PopupStatus) => {
    return status === PopupStatus.Open ? openPopup(popupId) : closePopups();
};

export class PopupModel {
    title: KnockoutObservable<string>;
    content: KnockoutObservable<string>;
    buttonText: KnockoutObservable<string>;
    buttonLoading: KnockoutObservable<boolean>;
    clickHandler: KnockoutObservable<() => void>;
    showCancelButton: KnockoutObservable<boolean>;

    constructor(title: string, content: string, buttonText: string) {
        this.title = ko.observable<string>(title);
        this.content = ko.observable<string>(content);
        this.buttonText = ko.observable<string>(buttonText);
        this.buttonLoading = ko.observable<boolean>(false);
        this.clickHandler = ko.observable<() => void>();
        this.showCancelButton = ko.observable<boolean>(false);
    }

    click() {
        this.clickHandler()();
    }

    closePopup() {
        closePopups();
    }

    configure(
        options: Partial<{
            title: string;
            content: string;
            buttonText: string;
            buttonLoading: boolean;
            clickHandler: () => void;
            showCancelButton: boolean;
        }>,
    ): void {
        Object.entries(options).forEach(([key, value]) => {
            if (value === undefined) return;
            const observable = (this as any)[key];
            if (ko.isObservable(observable)) {
                observable(value);
            }
        });
    }
}
